__turbopack_context__.v({
  "active": "YjCVhG_active",
  "anchor": "YjCVhG_anchor",
  "banners": "YjCVhG_banners",
  "disabled": "YjCVhG_disabled",
  "fullWidth": "YjCVhG_fullWidth",
  "iconContainer": "YjCVhG_iconContainer",
  "linkButton": "YjCVhG_linkButton",
  "neutral": "YjCVhG_neutral",
  "neutralOutline": "YjCVhG_neutralOutline",
  "neutralText": "YjCVhG_neutralText",
  "primary": "YjCVhG_primary",
  "primaryOutline": "YjCVhG_primaryOutline",
  "primaryText": "YjCVhG_primaryText",
  "secondary": "YjCVhG_secondary",
  "secondaryOutline": "YjCVhG_secondaryOutline",
  "secondaryText": "YjCVhG_secondaryText",
  "tertiary": "YjCVhG_tertiary",
  "tertiaryOutline": "YjCVhG_tertiaryOutline",
  "tertiaryText": "YjCVhG_tertiaryText",
  "textInherit": "YjCVhG_textInherit",
  "white": "YjCVhG_white",
  "whiteOutline": "YjCVhG_whiteOutline",
  "whiteText": "YjCVhG_whiteText",
});
